export enum UnitEnum {
    BYTE = "BYTE",
    SECOND = "SECOND",
    SECONDS = "SECONDS",
    MINUTES = "MINUTES",
    CENT = "CENT",
    GB = "GB",
    SMS = "SMS"
}